import { NextPageProps } from "@/utils/types"

import env from "./env.mjs"

export async function extractSearchParam(pageProps: NextPageProps, key: string) {
  const searchParams = await pageProps.searchParams
  const value = searchParams[key]
  if (typeof value === "string") {
    return value
  }

  if (Array.isArray(value)) {
    return value[0]
  }

  return
}

export function getBaseUrl() {
  if (typeof window !== "undefined") {
    // browser should use relative path
    return ""
  }

  if (process.env.VERCEL_URL) {
    // reference for vercel.com
    return `https://${process.env.VERCEL_URL}`
  }

  if (process.env.RENDER_INTERNAL_HOSTNAME) {
    // reference for render.com
    return `http://${process.env.RENDER_INTERNAL_HOSTNAME}:${process.env.PORT}`
  }

  if (env.BASE_URL) {
    // reference for local development
    return `https://${env.BASE_URL}`
  }

  // assume localhost
  return `http://localhost:${process.env.PORT ?? 3000}`
}
